// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k-form {
  position: relative;
  margin: auto;
  padding: 0;
  text-align: center;
}
.k-form .fieldset {
  margin: 0 auto 40px auto;
  border: none;
}
@media (max-width: 599px) {
  .k-form .fieldset {
    margin-bottom: 30px;
  }
  .k-form .fieldset legend {
    font-size: 20px;
    margin-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/commonComponents/forms/Form.less"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AADD;AAHA;EAQE,wBAAA;EACA,YAAA;AAFF;AAMA;EACC;IACC,mBAAA;EAJA;EAGD;IAIE,eAAA;IACA,mBAAA;EAJD;AACF","sourcesContent":["@import (reference) '../constants.less';\n\n.k-form {\n\tposition: relative;\n\tmargin: auto;\n\tpadding: 0;\n\ttext-align: center;\n\n\t.fieldset {\n\t\t@inputMargin: 25px;\n\t\tmargin: 0 auto 40px auto;\n\t\tborder: none;\n\t}\n}\n\n@media (max-width: @phoneOnlyMaxWidth) {\n\t.k-form .fieldset {\n\t\tmargin-bottom: 30px;\n\n\t\tlegend {\n\t\t\tfont-size: 20px;\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
